import { useMemo } from 'react';

var LOCK = false;
var TIMEOUT_CACHE;
function createOnTypeHandler(callbacks, delay) {
    return {
        onChange: function (event) {
            var _a, _b;
            (_a = callbacks.onChange) === null || _a === void 0 ? void 0 : _a.call(callbacks, event);
            if (!LOCK) {
                LOCK = true;
                (_b = callbacks.onTypeStart) === null || _b === void 0 ? void 0 : _b.call(callbacks, event.target.value);
            }
            TIMEOUT_CACHE && clearTimeout(TIMEOUT_CACHE);
            var cache = event.target.value;
            TIMEOUT_CACHE = setTimeout(function () {
                var _a;
                (_a = callbacks.onTypeFinish) === null || _a === void 0 ? void 0 : _a.call(callbacks, cache);
                LOCK = false;
            }, delay || 1000);
        },
    };
}
function useOnType(callbacks, delay) {
    return useMemo(function () {
        return createOnTypeHandler(callbacks, delay);
    }, [callbacks, delay]);
}

export { createOnTypeHandler, useOnType };
//# sourceMappingURL=index.es.js.map
